import { memo } from 'react';

import PropTypes from 'prop-types';

import {
    Button,
    Glyphicon,
    Image,
} from 'reaxl';

function renderCTA({
    label,
    link: href, // unfortunate rename of prop
    offsite,
    ...rest
}, isLeftAligned) {
    // Checks to not display Dealer Diff CTA button when the
    //  linkText and linkURL are null
    return label && href && (
        <div className={isLeftAligned ? 'text-left' : 'text-center'}>
            <Button
                bsStyle="primary"
                href={href}
                {...rest}
                target="_blank"
            >
                {label}
                {offsite && (
                    <Glyphicon
                        glyph="offsite"
                        className="margin-left-1"
                    />
                )}
            </Button>
        </div>
    );
}

function DealerDiff({
    cta = {},
    logo = {},
    htmlContent = '',
    isLeftAligned = false,
    ...rest
}) {
    return (
        <span
            data-cmp="dealerDiff"
            {...rest}
        >
            {logo && logo.src && (
                <Image
                    {...logo}
                    className="img-responsive"
                    lazyload={false}
                    loading="lazy"
                />
            )}
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
            {renderCTA(cta, isLeftAligned)}
        </span>
    );
}

DealerDiff.propTypes /* remove-proptypes */ = {
    /**
     * cta object for optional button on bottom of Dealer Diff Modal
     */
    cta: PropTypes.object,
    /**
     * logo object for optional image at top of Dealer Diff Modal
     */
    logo: PropTypes.object,
    /**
     * html blob of Dealer Diff modal content
     */
    htmlContent: PropTypes.string,
    /**
     * If true, the dealer diff CTA is aligned on the left.
     */
    isLeftAligned: PropTypes.bool,
};

export default memo(DealerDiff);
